// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"doctorInfo_mainContainer__35BOA","title":"doctorInfo_title__3Py-N"};